import React, { useMemo } from "react";
import filterImg from "../../common/images/filter.png";
import "./filterSelection.scss";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import InputLabel from "@mui/material/InputLabel";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import { apiQueryWithToken } from "../../common/services/apiBaseUrlConfig";
import logger from "../../common/utils/logger";

export const FilterSelections = ({
  handleData,
  viewFilter,
  onViewChange,
  tabValue,
  sector,
  setIsLoading,
}) => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedSectorId, setSectorId] = React.useState(0);
  const [selectedSubSectorId, setSubSectorId] = React.useState(0);
  const [selectedSubSubSectorId, setSubSubSectorId] = React.useState(0);
 const [selectedCountry, setCountry] = React.useState(0);
  const [selectedRegion, setRegion] = React.useState(0);
  const [selectedFunction, setFunction] = React.useState(0);
  const [selectedRevenue, setRevenue] = React.useState(0);
  const [selectedArea, setArea] = React.useState(0);
  const [filterData, setFilterData] = React.useState([]);

  const selectedSector = useMemo(() => {
    if (selectedSectorId > 0) {
      return filterData?.sectors?.find((item) => {
        return item.sectorId == selectedSectorId;
      })?.sectorId;
    } 
  }, [selectedSectorId]);

  const selectedSectorName = useMemo(() => {
    if (selectedSectorId > 0) {
      return filterData?.sectors?.find((item) => {
        return item.sectorId == selectedSectorId;
      })?.sectorName;
    }
    else {
      return "ALL";
    } 
  }, [selectedSectorId]);

  const selectedFunctionName = useMemo(() => {
    if (selectedFunction > 0) {
      return filterData?.functions?.find((item) => {
        return item.functionID == selectedFunction;
      })?.functionName;
    }  else {
      return "ALL";
    } 
  }, [selectedFunction]);

  const selectedRevenueName = useMemo(() => {
    if (selectedRevenue > 0) {
      return filterData?.revenueRanges?.find((item) => {
        return item.revenueRangeID == selectedRevenue;
      })?.range;
    }  else {
      return "ALL";
    } 
  }, [selectedRevenue]);

 
  const selectedSubSector = useMemo(() => {
    if (selectedSubSectorId > 0) {
      return filterData?.subSectorLists?.find((item) => {
        return item.subsectorID == selectedSubSectorId;
      })?.subsectorID;
    }  else {
      return 0;
    } 
  }, [selectedSubSectorId]);

  
  const selectedSubSectorName = useMemo(() => {
    if (selectedSubSectorId > 0) {
      return filterData?.subSectorLists?.find((item) => {
        return item.subsectorID == selectedSubSectorId;
      })?.subSectorName;
    }  else {
      return "ALL";
    } 
  }, [selectedSubSectorId]);

  const selectedAreaName = useMemo(() => {
    if (selectedArea > 0) {
      return filterData?.areas?.find((item) => {
        return item.areaID == selectedArea;
      })?.areaName;
    }  else {
      return "ALL";
    } 
  }, [selectedArea]);

  

  const selectedRegionName = useMemo(() => {
    if (selectedRegion > 0) {
      return filterData?.areaRegionCountryMappings?.find((item) => {
        return item.regionId == selectedRegion;
      })?.regionName;
    }  else {
      return "ALL";
    } 
  }, [selectedRegion]);

  
  const selectedCountryName = useMemo(() => {
    if (selectedCountry > 0) {
      return filterData?.areaRegionCountryMappings?.find((item) => {
        return item.countryId == selectedCountry;
      })?.countryName;
    }  else {
      return "ALL";
    } 
  }, [selectedCountry]);

  const selectedSubSubSector = useMemo(() => {
    if (selectedSubSubSectorId > 0) {
      return filterData?.subSubSectorLists?.find((item) => {
        return item.subSubSectorID == selectedSubSubSectorId;
      })?.subSubSectorName;
    }  else {
      return "ALL";
    } 
  }, [selectedSubSubSectorId]);

  React.useEffect(() => {
    setSearchParams({ sector: selectedSector });
    SectorSetFilteredData([
      {
        label: "Sector",
        value: selectedSectorName,
      },
    ]);
  }, [selectedSector]);

  const filtersSelections = [
    {
      label: "Sub Sector",
      value: "All",
    },
    {
      label: "Sub-Sub Sector",
      value: "All",
    },
    {
      label: "Country",
      value: "All",
    },
    {
      label: "Region",
      value: "All",
    },
    {
      label: "Function",
      value: "All",
    },
    {
      label: "Revenue Range",
      value: "All",
    },
  ];

  const sectorFilterSelection = [
    {
      label: "Sector",
      value: selectedSectorName,
    },
  ];

  const [filteredData, setFilteredData] = React.useState(filtersSelections);
  const [sectorFilteredData, SectorSetFilteredData] = React.useState(
    sectorFilterSelection
  );

  React.useEffect(() => {
    const cachedData = sessionStorage.getItem("applicationDataCache"); // Check session storage for cached data

    if (cachedData) {
      // If data exists in session storage, use it
      setSearchParams();
      const data = JSON.parse(cachedData);
      setFilterData(data);
      const id = data?.sectors?.find((item) => {
        return item.sectorName === sector
      })?.sectorId
      
      setSectorId(id); // Assuming the data is stored as JSON strings
      setIsLoading(false);
    } else {
      // If no cached data, make the API call
      setIsLoading(true);
      setSearchParams();
      apiQueryWithToken
        .get(`api/Insights/GetApplicationData`)
        .then((data) => {
          setIsLoading(false);
          setFilterData(data.data);

          // Store fetched data in session storage
          sessionStorage.setItem(
            "applicationDataCache", // Correct key name used here
            JSON.stringify(data.data)
          );

          // Set sectorId based on the fetched data
          const id = data.data.sectors?.find(
            (item) => item.sectorName === sector
          )?.sectorId;
          setSectorId(id);
        })
        .catch((error) => {
          setIsLoading(false);
          if (error.response && error.response.status === 401) {
            navigate("/"); // Handle unauthorized access
          } else {
            logger.error("An error occurred:", error);
          }
          logger.info(error);
        });
    }
  }, []);

  React.useEffect(() => {
    resetFilterDialog();
  }, [tabValue]);

  React.useEffect(() => {
    searchParams.size > 0 && selectedSector &&
      handleData({
        selectedSector,
        selectedSubSector,
        selectedSubSubSectorId,
        selectedCountry,
        selectedRegion,
        selectedFunction,
        selectedRevenue,
        selectedArea
      });
  }, [searchParams.size, selectedSector]);

  const handleFilteredData = () => {
    closeFilterDialog();
    setFilteredData([
      {
        label: "SubSector",
        value: selectedSubSectorName,
      },
      {
        label: "Sub-Sub Sector",
        value: selectedSubSubSector,
      },
      {
       label:"Area",
       value:selectedAreaName
      },
      {
        label: "Country",
        value: selectedCountryName,
      },
      {
        label: "Region",
        value: selectedRegionName,
      },
      {
        label: "Function",
        value: selectedFunctionName,
      },
      {
        label: "Revenue Range",
        value: selectedRevenueName,
      },
    ]);
    selectedSector && handleData({
      selectedSector,
      selectedSubSector,
      selectedSubSubSectorId,
      selectedCountry,
      selectedRegion,
      selectedFunction,
      selectedRevenue,
      selectedArea
    });
  };

  const closeFilterDialog = () => {
    const element = document.getElementById("filter-outer");
    element.style.visibility = "hidden";
  };

  const resetFilterDialog = () => {
    setFilteredData(filtersSelections);
    setSubSectorId(0);
    setSubSubSectorId(0);
    setCountry(0);
    setRegion(0);
    setFunction(0);
    setRevenue(0);
    setArea(0);
  };
  const handleSectorChange = (event) => {
    resetFilterDialog();
    setSectorId(event.target.value);
  };

  const handleOnChange = (event) => {
    closeFilterDialog();
    onViewChange(event);
  };

  const showFilterDialog = () => {
    const element = document.getElementById("filter-outer");
    if (element.style.visibility === "visible") {
      element.style.visibility = "hidden";
    } else {
      element.style.visibility = "visible";
    }
  };

  return (
    selectedSector && (
      <React.Fragment>
        <div className="filters-wrapper">
          <div className="filter-dropdown">
            {tabValue == "1" ? (
              <div className="v-align">
                <span>View by</span>
                <select value={viewFilter} onChange={handleOnChange}>
                  <option value="period">Period</option>
                  <option value="percentile">Percentile</option>
                </select>
              </div>
            ) : null}

            <button
              onClick={showFilterDialog}
              className="v-align filters-button"
              type="button"
            >
              <img src={filterImg} alt="filter" />
              Filters
            </button>

            <div id="filter-outer">
              <DialogActions className="dialog-actions">
                <div className="dialog-buttons">
                  <Button onClick={resetFilterDialog} className="filter-button">
                    Reset
                  </Button>
                  <Button
                    onClick={handleFilteredData}
                    className="filter-button"
                  >
                    Apply
                  </Button>
                </div>
                <div onClick={closeFilterDialog} className="closeIcon">
                  <img
                    src={require("../../common/images/closeIcon.png")}
                    alt="close-icon"
                  />
                </div>
              </DialogActions>

              <div className="filter-inner">
                <Box
                  component="form"
                  sx={{ display: "flex", flexWrap: "wrap" }}
                  className="filter-box"
                >
                  <FormControl sx={{ m: 1, minWidth: 120 }} className="filters">
                    <InputLabel htmlFor="demo-dialog-native">
                      Sub Sector
                    </InputLabel>
                    <Select
                      id="dialog-subSector"
                      value={selectedSubSectorId}
                      onChange={(event) => {
                        setSubSubSectorId(0);
                        setSubSectorId(event.target.value);
                      }}
                      input={<OutlinedInput label="Sub Sector" />}
                      className="select-input"
                      disabled={tabValue === "3"}
                    >
                      <MenuItem value={0}>All</MenuItem>
                      {filterData.subSectorLists
                        ?.filter((item) => {
                          return item.sectorId == selectedSectorId;
                        })
                        .map((sector) => {
                          return (
                            <MenuItem
                              key={sector.subsectorID}
                              value={sector.subsectorID}
                            >
                              {sector.subSectorName}
                            </MenuItem>
                          );
                        })}
                    </Select>
                  </FormControl>
                </Box>
                <Box
                  component="form"
                  sx={{ display: "flex", flexWrap: "wrap" }}
                  className="filter-box"
                >
                  <FormControl sx={{ m: 1, minWidth: 120 }} className="filters">
                    <InputLabel htmlFor="demo-dialog-native">
                      Sub-Sub Sector
                    </InputLabel>
                    <Select
                      id="dialog-subsubSector"
                      value={selectedSubSubSectorId}
                      onChange={(event) =>
                        setSubSubSectorId(event.target.value)
                      }
                      input={<OutlinedInput label="Sub Sub Sector" />}
                      className="select-input"
                      disabled={tabValue === "3"}
                    >
                      <MenuItem value={0}>All</MenuItem>
                      {filterData.subSubSectorLists
                        ?.filter((item) => {
                          return item.subsectorID == selectedSubSectorId;
                        })
                        .map((sector) => {
                          return (
                            <MenuItem
                              key={sector.subSubSectorID}
                              value={sector.subSubSectorID}
                            >
                              {sector.subSubSectorName}
                            </MenuItem>
                          );
                        })}
                    </Select>
                  </FormControl>
                </Box>
                <Box
                  component="form"
                  sx={{ display: "flex", flexWrap: "wrap" }}
                  className="filter-box"
                >
                  <FormControl sx={{ m: 1, minWidth: 120 }} className="filters">
                    <InputLabel htmlFor="demo-dialog-native">Area</InputLabel>
                    <Select
                      id="dialog-area"
                      value={selectedArea}
                      onChange={(event) => {
                        setArea(event.target.value);
                        if (event.target.value==0 ) {
                          setRegion(0);
                          setCountry(0);
                        }
                      }}
                      input={<OutlinedInput label="Area" />}
                      className="select-input"
                    >
                      <MenuItem value={0}>All</MenuItem>
                      {filterData.areas?.map((area) => {
                        return (
                          <MenuItem
                            key={area.areaID}
                            value={area.areaID}
                          >
                            {area.areaName}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </Box>
               
              </div>
              <div className="filter-inner">
              <Box
                  component="form"
                  sx={{ display: "flex", flexWrap: "wrap" }}
                  className="filter-box"
                >
                  <FormControl sx={{ m: 1, minWidth: 120 }} className="filters">
                    <InputLabel htmlFor="demo-dialog-native">Region</InputLabel>
                    <Select
                      id="dialog-region"
                      value={selectedRegion}
                      onChange={(event) => {
                        setRegion(event.target.value);
                        if (event.target.value==0) {
                          setCountry(0);
                        }
                      }}
                      input={<OutlinedInput label="Region" />}
                      className="select-input"
                    >
                      <MenuItem value={0}>All</MenuItem>

                      {
                        (() => {
                          const uniqueRegions = new Map(); // Create a map to track unique region names and IDs
                          filterData?.areaRegionCountryMappings
                            ?.filter((areas) => areas.areaID === selectedArea) // Use areaID to match with selectedArea
                            .forEach((item) => {
                              // Use a combination of regionName and regionId as the key
                              const key = `${item.regionName}-${item.regionId}`;
                              if (!uniqueRegions.has(key)) {
                                uniqueRegions.set(key, {
                                  regionName: item.regionName,
                                  regionId: item.regionId,
                                });
                              }
                            });

                          return Array.from(uniqueRegions.values()).map((region) => ( // Convert the map values to an array and map over it
                            <MenuItem
                              key={region.regionId} // Use regionId as the key for React elements
                              value={region.regionId} // Use regionName as the value for the select option
                            >
                              {region.regionName}
                            </MenuItem>
                          ));
                        })()
                      }
                    </Select>
                  </FormControl>
                </Box>
                <Box
                  component="form"
                  sx={{ display: "flex", flexWrap: "wrap" }}
                  className="filter-box"
                >
                  <FormControl sx={{ m: 1, minWidth: 120 }} className="filters">
                    <InputLabel htmlFor="demo-dialog-native">
                      Country
                    </InputLabel>
                    <Select
                      id="dialog-country"
                      value={selectedCountry}
                      onChange={(event) => setCountry(event.target.value)}
                      input={<OutlinedInput label="Country" />}
                      className="select-input"
                    >
                      <MenuItem value={0}>All</MenuItem>
                      {
                        (() => {
                          const uniqueCountries = new Map(); // Create a map to track unique country names and IDs
                          filterData?.areaRegionCountryMappings
                            ?.filter((regions) =>  regions.regionId === selectedRegion) // Use regionName and regionId to match with selectedRegion
                            .forEach((item) => {
                              // Use a combination of countryName and countryId as the key
                              const key = `${item.countryName}-${item.countryId}`;
                              if (!uniqueCountries.has(key)) {
                                uniqueCountries.set(key, {
                                  countryName: item.countryName,
                                  countryId: item.countryId,
                                });
                              }
                            });

                          return Array.from(uniqueCountries.values()).map((country) => ( // Convert the map values to an array and map over it
                            <MenuItem
                              key={country.countryId} // Use countryId as the key for React elements
                              value={country.countryId} // Use countryName as the value for the select option
                            >
                              {country.countryName}
                            </MenuItem>
                          ));
                        })()
                      }
                    </Select>
                  </FormControl>
                </Box>
              </div>
              <div className="filter-inner">
              <Box
                  component="form"
                  sx={{ display: "flex", flexWrap: "wrap" }}
                  className="filter-box"
                >
                  <FormControl sx={{ m: 1, minWidth: 120 }} className="filters">
                    <InputLabel htmlFor="demo-dialog-native">
                      Function
                    </InputLabel>
                    <Select
                      id="dialog-function"
                      value={selectedFunction}
                      onChange={(event) => setFunction(event.target.value)}
                      input={<OutlinedInput label="Function" />}
                      className="select-input"
                      disabled={tabValue === "3"}
                    >
                      <MenuItem value={0}>All</MenuItem>
                      {filterData?.functions?.map((sector) => {
                        return (
                          <MenuItem
                            key={sector.functionID}
                            value={sector.functionID}
                          >
                            {sector.functionName}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </Box>
                <Box
                  component="form"
                  sx={{ display: "flex", flexWrap: "wrap" }}
                  className="filter-box"
                >
                  <FormControl sx={{ m: 1, minWidth: 120 }} className="filters">
                    <InputLabel
                      htmlFor="demo-dialog-native"
                      className="filter-label"
                    >
                      Revenue Range
                    </InputLabel>
                    <Select
                      id="dialog-range"
                      value={selectedRevenue}
                      onChange={(event) => setRevenue(event.target.value)}
                      input={<OutlinedInput label="RevenueRange" />}
                      className="select-input"
                      disabled={tabValue === "3"}
                    >
                      <MenuItem value={0}>All</MenuItem>
                      {filterData?.revenueRanges?.map((sector) => {
                        return (
                          <MenuItem key={sector.revenueRangeID} value={sector.revenueRangeID}>
                            {sector.range}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </Box>
              </div>
            </div>
          </div>
          <div className="v-align">
            <select value={selectedSectorId} onChange={handleSectorChange}>
              {filterData?.sectors?.map((item) => {
                return (
                  <option key={item.sectorId} value={item.sectorId}>
                    {item.sectorName}
                  </option>
                );
              })}
            </select>
          </div>
        </div>
        <div id="filter-labels">
          <strong>Filter Selections: </strong>
          {sectorFilteredData?.map((item, index) => (
            <span className="filter-selection" key={`label_${index}`}>
              {item.label}: <strong>{item.value}</strong>
            </span>
          ))}
          {filteredData?.map((item, index) => (
            <span className="filter-selection" key={`label_${index}`}>
              {item.label}: <strong>{item.value}</strong>
            </span>
          ))}
        </div>
      </React.Fragment>
    )
  );
};
